import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <>
      <title>Página no encontrada | Toldos Málaga</title>
      <meta name="description" content="La página que buscas no existe. Vuelve al inicio de Toldos Málaga para reparación e instalación de toldos en Málaga." />
      <meta name="robots" content="noindex, follow" />
      <link rel="canonical" href="https://toldos-malaga.es/" />
      <meta property="og:title" content="Página no encontrada | Toldos Málaga" />
      <meta property="og:description" content="La página que buscas no existe. Vuelve al inicio de Toldos Málaga para reparación e instalación de toldos en Málaga." />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://toldos-malaga.es/" />
      <meta property="og:image" content="https://toldos-malaga.es/og-image.jpg" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content="Toldos Málaga" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Página no encontrada | Toldos Málaga" />
      <meta name="twitter:description" content="Vuelve al inicio de Toldos Málaga. Reparación e instalación de toldos." />
      <meta name="twitter:image" content="https://toldos-malaga.es/og-image.jpg" />

      <main className="min-h-screen bg-background-50 flex flex-col items-center justify-center text-center px-4">
        <div className="relative">
          <h1 className="absolute bottom-0 left-1/2 -translate-x-1/2 text-9xl md:text-[12rem] font-black text-foreground-100 select-none pointer-events-none z-0">
            404
          </h1>
          <div className="relative z-10 flex flex-col items-center gap-4 pt-20">
            <div className="w-16 h-16 rounded-2xl bg-primary-100 flex items-center justify-center mb-2">
              <i className="ri-error-warning-line text-primary-500 text-2xl"></i>
            </div>
            <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground-900">
              Página no encontrada
            </h2>
            <p className="text-base text-foreground-500 max-w-md">
              La dirección <code className="text-xs bg-background-100 px-2 py-0.5 rounded text-primary-600 font-mono">{location.pathname}</code> no existe en este sitio.
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-3 pt-4">
              <Link
                to="/"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white text-sm font-semibold rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
              >
                <i className="ri-home-line text-lg"></i>
                <span>Volver al inicio</span>
              </Link>
              <Link
                to="/guias"
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-100 border border-background-200 text-foreground-700 text-sm font-semibold rounded-full hover:bg-background-200 hover:text-primary-500 transition-all duration-300 whitespace-nowrap"
              >
                <i className="ri-book-open-line text-lg"></i>
                <span>Ver guías de reparación</span>
              </Link>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}